import { observable, action, makeObservable } from "mobx";
import ApiBasedStore from "./ApiBasedStore";

export default class DeeplinksStore extends ApiBasedStore {
  pathStats = new Map();

  constructor(rootStore, api) {
    super(rootStore);
    this.api = api;
    makeObservable(this, {
      pathStats: observable,
      fetchPathStats: action,
    });
  }

  async fetchPathStats(path) {
    try {
      this.startRequest(false);
      const response = await this.api.getStats(path);
      
      this.pathStats.set(path, response);
      
      this.endRequest();
      return response;
    } catch (error) {
      this.onError(error);
      throw error;
    }
  }

  getPathStats(path) {
    return this.pathStats.get(path);
  }
}